export default "__VITE_ASSET__CrQEqiP___"